<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            :fullscreen="windowWidth < 700">

        <el-form :model="obj"
                 ref="addEditForm" status-icon
                 :rules="rules"> <!--:rules="rulesUser"-->
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="date">
                        <el-date-picker
                                v-model="obj.date"
                                type="date"
                                class="w-full"
                                placeholder="Datum"
                                :picker-options="dueDatePickerOptions">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="branch">
                        <el-select v-model="obj.branchId"
                                   placeholder="Tak"
                                   class="w-full">
                            <span slot="prefix"><i class="el-icon-medal pl-1"></i></span>
                            <el-option
                                    v-for="item in nonPseudoBranches"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    :disabled="$store.getters.getBranches.indexOf(item.id) < 0 || item.pseudo">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="startTime">
                        <el-time-picker
                                class="w-full"
                                v-model="obj.startTime"
                                :picker-options="{
                                     selectableRange: '10:00:00 - 23:00:00'
                                }"
                                format="HH:mm"
                                placeholder="Starttijd">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="endTime">
                        <el-time-picker
                                v-model="obj.endTime"
                                :picker-options="{
                                    selectableRange: '10:00:00 - 23:00:00'
                                }"
                                class="w-full"
                                format="HH:mm"
                                placeholder="Eindtijd">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="annotation">
                        <el-input type="textarea"
                                  v-model="obj.annotation"
                                  placeholder="Beschrijving"
                                  maxlength="60"
                                  show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Annuleer</el-button>
            <el-button type="primary" @click="submitForm('addEditForm')" :loading="loading">Opslaan</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "PerformanceDialog",
        props: ["branchOptions"],
        data() {
            return {
                dialogTitle: "",
                itemName: "Prestatie",
                dialogVisible: false,
                adding: false,
                obj: this.getEmptyObject(),
                loading: false,
                windowWidth: window.innerWidth,
                dueDatePickerOptions: {
                    disabledDate: this.disabledDueDate
                },

                // Rules
                rules: {
                    date: [
                        {required: true, message: 'Selecteer een datum.', trigger: 'blur'}
                    ],
                    startTime: [
                        {required: true, message: 'Selecteer begintijd.', trigger: 'blur'}
                    ],
                    endTime: [
                        {required: true, message: 'Selecteer eindtijd.', trigger: 'blur'}
                    ],
                    branchId: [
                        {required: true, message: 'Selecteer een tak.', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            edit(obj) {
                this.dialogTitle = `${this.itemName} wijzigen`
                this.dialogVisible = true
                this.adding = false
                this.obj = JSON.parse(JSON.stringify(obj));
            },
            add() {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
            },
            getEmptyObject() {
                return {
                    // Form data
                    date: "",
                    startTime: new Date(),
                    endTime: new Date(),
                    branchId: "",
                    annotation: "",
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        if (this.adding) {
                            this.$parent.objAdded(this.obj);
                        } else {
                            this.$parent.objEdited(this.obj);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: 'Gelieve alle informatie correct in te vullen.',
                            type: 'error'
                        });
                        return false;
                    }
                });
            },
            disabledDueDate (time) {
                return time > new Date()
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            }
        },
        mounted() {
            window.onresize = () => {
                this.windowWidth = window.innerWidth
            }
        },
        computed: {
            nonPseudoBranches() {
                if (this.branchOptions) {
                    return this.branchOptions.filter(e => {
                        return !e.pseudo
                    })
                } else {
                    return []
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/prestations/dialogs/PerformanceDialog.vue